/* Form Page to create a Latest Post
 * Latest is a department choice in the Depts-Xtra app
   So all requests are to department */
import React, { useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Asset from "../../components/Asset"

import Upload from "../../assets/upload.png"
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import { useRedirect } from "../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

function LatestCreate({ setShow }) {
  useRedirect();
  const host = useHostName();
  const [errors, setErrors] = useState({});

  const [postData, setPostData] = useState({
    title: "",
    content: "",
    departments: "latest",
    image1: "",
    image1Preview: null,
  })
  const { title, content, departments, 
    // eslint-disable-next-line
    image1 } = postData
  const imageInput1 = useRef(null)

  const history = useHistory()

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  // const handleChangeImage1 = (event) => {
  //   if (event.target.files.length) {
  //     URL.revokeObjectURL(image1)
  //     setPostData({
  //       ...postData,
  //       image1: URL.createObjectURL(event.target.files[0]),
  //     })
  //     console.log(`image1 ${image1}`)
  //   }
  // }

  const handleChangeImage1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (postData.image1Preview) {
        URL.revokeObjectURL(postData.image1Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image1: file,
        image1Preview: previewUrl,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault()
    setPostData({
      ...postData,
    })
    const formData = new FormData()

    formData.append("title", title)
    formData.append("content", content)
    formData.append("departments", departments)
    if (imageInput1.current.files[0]) {
      formData.append("image1", imageInput1.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.post("/department/posts/", formData)
        toast.success(`Post Added`);
        history.push(
          `/${localStorage.getItem("projectSlug")}/latest/post/${data.id}`
        )
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/department/posts/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        history.push(
          `/${localStorage.getItem("projectSlug")}/latest/post/${data.id}`
        )
        toast.success(`Post Added Successfully!`);
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const textFields = (
      <div>
      <Row className="mt-3">
      <Col className="d-flex justify-content-center">
      <Form.Group controlId="title" className={`${styles.Width2} text-center`}>
                <Form.Label className={`${styles.BoldScene} `} >Title</Form.Label>
                <Form.Control 
                className={styles.Input}
                type="text"
                name="title"
                value={title}
                onChange={handleChange}
                    />
      </Form.Group>
      {errors?.title?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      <Row className="mt-3">
      <Col className="d-flex justify-content-center">
      <Form.Group controlId="content" className={`${styles.Width95} text-center`} >
      <Form.Label className={`${styles.BoldScene} `} >Content</Form.Label>
      <Form.Control 
          className={styles.InputScene}
          type="text"
          name="content"
          as="textarea"
          rows={2}
          value={content}
          onChange={handleChange}
          />
        </Form.Group>
        {errors?.content?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>
      </div>
  )

  const buttons = (
    <div className="text-center">    
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => setShow(false)}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Create
      </Button>
    </div>
  );

  return (
    <div>
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 style={{ textTransform: 'uppercase'}} 
        className={`text-center mt-3 py-1 ${styles.SubTitle }`}>
        Create Latest Buzz Post</h5>
        <Form className={` ${styles.White }`} onSubmit={handleSubmit}>
        <Row>
          <Col md={6} className="">
            <Container className={`${appStyles.Content} ${styles.Container}`}>
              {textFields}
            </Container>
          </Col>
          <Col className="mt-3" md={6}>
          <p className={`${styles.BoldScene} 
                      mb-0 text-center mx-3`} >Image/PDF</p>
            <div className={`mt-3 p-0 d-flex flex-column justify-content-center`}>
            <Form.Group className="text-center">
                {postData.image1Preview ? (
                  postData.image1?.type === "application/pdf" ? (
                    <>
                      <iframe
                        src={postData.image1Preview}
                        width="40%"
                        height="100px"
                        style={{ borderRadius: 8, border: "none" }}
                        title="PDF Preview"
                      />
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.Blue}`}
                        htmlFor="image-upload1"
                      >
                        Change the file
                      </Form.Label>
                    </>
                  ) : (
                    <>
                      <figure>
                        <Image
                          className={appStyles.iframe}
                          width="70%"
                          height="120px"
                          style={{ borderRadius: 8, border: "none" }}
                          src={postData.image1Preview}
                          rounded
                        />
                      </figure>
                      <Form.Label
                        className={`${btnStyles.Button} ${btnStyles.Blue}`}
                        htmlFor="image-upload1"
                      >
                        Change the image
                      </Form.Label>
                    </>
                  )
                ) : (
                  <Form.Label
                    htmlFor="image-upload1"
                  >
                    <Asset
                      src={Upload}
                      message="Upload Image or PDF"
                    />
                  </Form.Label>
                )}
                <Form.Control
                  type="file"
                  id="image-upload1"
                  accept="image/*,application/pdf"
                  onChange={handleChangeImage1}
                  ref={imageInput1}
                />
            </Form.Group>
            {errors?.image1?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={` mt-3`}>
              {buttons}{" "}
            </div>
          </Col>
        </Row>
      </Form>
      <Row className=''>
        <Col xs={2} ></Col>
        <Col xs={8}>
        <hr className={`${styles.Break} mt-4`}/>
        </Col>
        </Row>
      </Col>
      </Row>
    </div>
  )
}

export default LatestCreate
